export default "__VITE_ASSET__2_uxSH$7__"